/** Types fondamentaux de la simulation. Aucune dépendance Phaser/DOM ici. */

/**
 * Inputs d'un pilote pour une frame. La MÊME structure est produite par un humain
 * (clavier/manette) ou par l'IA — c'est la clé de l'architecture découplée.
 */
export interface CarInput {
  /** Accélération [0..1]. */
  throttle: number;
  /** Frein [0..1]. */
  brake: number;
  /** Braquage [-1..1] (négatif = gauche). */
  steer: number;
  /** Frein à main (drift). */
  handbrake: boolean;
}

export function neutralInput(): CarInput {
  return { throttle: 0, brake: 0, steer: 0, handbrake: false };
}

/** État complet d'une voiture à une frame donnée (snapshot sérialisable). */
export interface CarState {
  id: string;
  /** Longueur du corps (px, dans le sens du cap). Partagé physique Matter <-> rendu. */
  w: number;
  /** Largeur latérale du corps (px). */
  h: number;
  /** Position monde (px). */
  x: number;
  y: number;
  /** Cap (radians) ; 0 = vers +x, croît dans le sens horaire (y vers le bas). */
  angle: number;
  /** Vélocité (px/s). */
  vx: number;
  vy: number;
  /** Norme de la vélocité (px/s). */
  speed: number;
  /** Vitesse angulaire (rad/s). */
  angularVelocity: number;
  /** Braquage réel courant [-1..1] (sortie de l'actionneur de direction ; suit la commande avec délai). */
  steerAngle: number;
  /** Composante latérale de la vélocité (px/s) — utile au debug du drift. */
  lateralSlip: number;
  /** Grip courant [0..1] (placeholder en M0, piloté par les surfaces plus tard). */
  grip: number;
  /** Tour courant (0 au départ). */
  lap: number;
  /** Index du dernier checkpoint validé (-1 = aucun). */
  checkpointIdx: number;
  /** Profondeur de pénétration max dans un mur ce pas (px) — doit rester ~0 (M2). */
  penetration: number;
  /** Place au classement (1 = en tête). */
  position: number;
  /** À contre-sens ? */
  wrongWay: boolean;
  /** Temps du dernier tour bouclé (s ; 0 si aucun). */
  lastLapTime: number;
  /** Meilleur temps au tour (s ; 0 si aucun). */
  bestLapTime: number;
}

/** Snapshot immuable du monde, renvoyé par World.getState(). */
export interface WorldState {
  /** Nombre de pas fixes écoulés. */
  step: number;
  /** Temps simulé écoulé (s). */
  time: number;
  cars: CarState[];
}
